import { createFileRoute } from "@tanstack/react-router";
import { cancellationPolicy } from "@/lib/cancellation-policy";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PAYMENT_POLICY } from "@/lib/payment-notice";

const URL = "https://www.mostrandomexico.mx/terminos";

export const Route = createFileRoute("/terminos")({
  head: () => ({
    meta: [
      { title: "Términos y Condiciones — Mostrando México" },
      {
        name: "description",
        content:
          "Términos y condiciones de uso, contratación y reservas de Mostrando México. Tours, vuelos y experiencias en México.",
      },
      { property: "og:title", content: "Términos y Condiciones — Mostrando México" },
      { property: "og:description", content: "Condiciones de uso y contratación." },
      { property: "og:url", content: URL },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: TerminosPage,
});

function TerminosPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <h1 className="font-display text-4xl font-semibold">Términos y Condiciones</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Última actualización: junio 2026
        </p>

        <div className="prose prose-neutral mt-8 max-w-none text-foreground/85">
          <h2>1. Aceptación de los términos</h2>
          <p>
            Al utilizar el sitio www.mostrandomexico.mx, contratar tours, vuelos o cualquier
            experiencia ofrecida por Mostrando México (Company Mostrando Mexico, Cancún,
            Quintana Roo, México), el usuario acepta íntegramente los presentes Términos y
            Condiciones, así como nuestra Política de Privacidad.
          </p>

          <h2>2. Servicios ofrecidos</h2>
          <p>
            Mostrando México es una agencia de viajes que comercializa tours, traslados, vuelos
            y experiencias en territorio mexicano, ya sea de forma directa o a través de
            operadores y plataformas verificadas (Bokun, TripAdvisor, Civitatis, entre otros).
          </p>

          <h2>3. Reservas y pagos</h2>
          <p>
            Las reservas se confirman al recibir el pago total mediante los métodos disponibles
            (VISA, MasterCard, American Express, Diners Club). Los precios pueden
            estar expresados en MXN o USD y están sujetos a disponibilidad y temporada.
          </p>

          <p>{PAYMENT_POLICY.es}</p>

          <h2>4. Cambios y cancelaciones</h2>
          <p>
            Aplica la siguiente política a todas las reservas. Si la página del tour indica
            condiciones más flexibles para el viajero, prevalecen esas. Para detalles, consulta
            nuestra{" "}
            <a href="/cancellation" className="text-primary hover:underline">
              Política de Cancelación
            </a>
            .
          </p>
                    <ul>
            {cancellationPolicy("es").map((l) => (
              <li key={l}>{l}</li>
            ))}
          </ul>

          <h2>5. Responsabilidad del viajero</h2>
          <p>
            El viajero es responsable de presentarse a tiempo en el punto de encuentro, contar
            con documentación de identidad vigente, declarar condiciones médicas relevantes y
            seguir las indicaciones de guías y operadores. Mostrando México no se hace
            responsable por pérdidas derivadas de incumplimiento de estas obligaciones.
          </p>

          <h2>6. Limitación de responsabilidad</h2>
          <p>
            Mostrando México actúa como intermediario entre el viajero y los proveedores
            finales de servicios turísticos. Los riesgos inherentes a actividades como buceo,
            snorkel, ATV, vuelos y excursiones acuáticas son asumidos por el viajero.
          </p>

          <h2>7. Propiedad intelectual</h2>
          <p>
            Todo el contenido del sitio (textos, imágenes, marcas, código) es propiedad de
            Mostrando México o sus licenciantes y está protegido por las leyes mexicanas e
            internacionales aplicables.
          </p>

          <h2>8. Modificaciones</h2>
          <p>
            Nos reservamos el derecho de modificar estos Términos en cualquier momento.
            La versión vigente será siempre la publicada en esta página.
          </p>

          <h2>9. Legislación aplicable</h2>
          <p>
            Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier
            controversia se resolverá ante los tribunales competentes de Cancún, Quintana Roo.
          </p>

          <h2>10. Contacto</h2>
          <p>
            Para dudas o reclamaciones: <a href="mailto:info@mostrandomexico.mx" className="text-primary">info@mostrandomexico.mx</a>{" "}
            · WhatsApp <a href="https://wa.me/529983381476" className="text-primary">+52 998 338 1476</a>.
          </p>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
